import { Client, ClientType } from '@packlink/packlink-sdk';

const getPostalAndCountryOptions = (client, from) => {
  let country = null;
  let postalCode = null;

  // Create Country option value
  // Old clients only have alpha2Code
  // State property it's filled inside "InvoiceAddressForm.tsx"
  if (client !== null && client !== void 0 && client.alpha2Code) {
    country = {
      label: client.state || '',
      value: client.alpha2Code
    };
  } else if (from !== null && from !== void 0 && from.state && from !== null && from !== void 0 && from.alpha2Code) {
    country = {
      label: from.state,
      value: from.alpha2Code
    };
  }

  // Create PostalCode option value
  if (client !== null && client !== void 0 && client.zipCode && client !== null && client !== void 0 && client.location) {
    postalCode = {
      label: `${client.zipCode} - ${client.location}`,
      value: client.zipCode
    };
    // Do not set postalCode if the client is from a different country
  } else if (from !== null && from !== void 0 && from.zipCode && from !== null && from !== void 0 && from.city && ((client === null || client === void 0 ? void 0 : client.alpha2Code) === from.alpha2Code || !(client !== null && client !== void 0 && client.alpha2Code))) {
    postalCode = {
      label: `${from.zipCode} - ${from.city}`,
      value: from.zipCode
    };
  }
  return {
    country,
    postalCode
  };
};
const parseClientOrAddressToFormData = (client, from, showDefaultPhoneInput, defaultPrefixValue) => ({
  companyName: (client === null || client === void 0 ? void 0 : client.companyName) || (from === null || from === void 0 ? void 0 : from.company) || '',
  taxId: (client === null || client === void 0 ? void 0 : client.taxId) || '',
  firstName: (client === null || client === void 0 ? void 0 : client.firstName) || (from === null || from === void 0 ? void 0 : from.firstName) || '',
  lastName: (client === null || client === void 0 ? void 0 : client.lastName) || (from === null || from === void 0 ? void 0 : from.lastName) || '',
  phone: showDefaultPhoneInput ? (client === null || client === void 0 ? void 0 : client.phone) || (from === null || from === void 0 ? void 0 : from.phone) || '' : {
    prefix: defaultPrefixValue || {
      value: '',
      alpha2Code: '',
      label: ''
    },
    number: ''
  },
  email: (client === null || client === void 0 ? void 0 : client.email) || (from === null || from === void 0 ? void 0 : from.email) || '',
  address: (client === null || client === void 0 ? void 0 : client.address) || (from === null || from === void 0 ? void 0 : from.street1) || '',
  ...getPostalAndCountryOptions(client, from)
});
const parseFormDataToClient = (_ref, type, postalCode, country, client) => {
  let {
    ...form
  } = _ref;
  if (!country || !postalCode) {
    throw new Error('Unexpected nullish country or postalCode');
  }
  return Client.deserialize({
    ...(client === null || client === void 0 ? void 0 : client.toJSON()),
    ...form,
    phone: typeof form.phone !== 'string' ? form.phone.prefix.value + form.phone.number : form.phone,
    alpha2Code: country.alpha2Code,
    state: country.name,
    location: postalCode.city,
    city: postalCode.city,
    zipCode: postalCode.zipCode,
    type,
    ...(type === ClientType.AUTONOMOUS ? {
      companyName: undefined,
      taxId: undefined
    } : {
      firstName: undefined,
      lastName: undefined
    })
  });
};

export { parseClientOrAddressToFormData, parseFormDataToClient };
//# sourceMappingURL=transformData.js.map
